import React, { useState, useRef, useEffect } from "react"
import { Link } from "gatsby"
import * as styles from './header.module.scss'
import { SearchBlock } from "../search/SearchBlock"
import { MobileMenu } from "./MobileMenu"

import settings from "../../helpers/settings"

export const Header = ({ allPosts }) => {

    const headerRef = useRef( null )
 
    const menuItems = settings[ process.env.GATSBY_SITE_LANG ].headerMenu 

    const siteUrl = process.env.GATSBY_SITE_LANG

    const [ search, setSearch ] = useState( false )

    const [ mobileMenu, setMobileMenu ]  = useState( false )

    const burgerRef = useRef( null )

    const mobileMenuHandler = () => {
        
        burgerRef.current !== null && burgerRef.current.classList.contains('activeBurger') ? burgerRef.current.classList.remove('activeBurger') : burgerRef.current.classList.add('activeBurger')

        setMobileMenu( mobileMenu ? false : true )
      
    }

    useEffect(() => {
        // Make header sticky
        const header = headerRef.current
        const sticky = header.offsetTop
        const scrollCallBack = window.addEventListener("scroll", () => {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky")
            } else {
                header.classList.remove("sticky")
            }
        })
        
    }, [])

    useEffect(() => {

        // If window height is less than 768px, remove class 'vertical-submenu' from menu items
        if (window.innerHeight < 700) {
            
            const menuItems = document.querySelectorAll('.vertical-submenu')
            menuItems.forEach( item => {
                item.classList.remove('vertical-submenu')
                item.classList.add('horizontal-submenu')
            } )
        }

        // Make the same on resize 
        window.addEventListener('resize', () => {
            console.log(window.innerHeight)
            if (window.innerHeight < 700) {
                const menuItems = document.querySelectorAll('.vertical-submenu')
                menuItems.forEach( item => {
                    item.classList.remove('vertical-submenu')
                    item.classList.add('horizontal-submenu')
                } )
            } else {
                const menuItems = document.querySelectorAll('.main-menu__item')
                menuItems.forEach( item => {
                    item.classList.add('vertical-submenu')
                    item.classList.remove('horizontal-submenu')
                } )
            }
        }) 
        
        
        
    }, [])

    const lang = process.env.GATSBY_SITE_LANG
    
    return(
        <>
        <header ref={headerRef}
            className={`header`}
            id="mainHeader"
           >
            <div className={`wrapper ${styles.headerWrapper}`} >
                <div className="">
                        <Link to="/">
                            <img 
                                src={settings[ process.env.GATSBY_SITE_LANG ].logo} 
                                className={`${styles.mainLogo} m-logo`} 
                                alt={ lang === 'en' ? 'Bedbible logo - Sexual Wellness Insights & Sex Toy Reviews' : 'Lovefreund logo - Einblicke in sexuelle Wellness und Sexspielzeug-Bewertungen'} />
                        </Link>                
                    </div>
                    <div className={`${styles.menuBlock} `}>
                        <ul className={`main-menu ${styles.mainMenu}`}>
                            {!search &&
                            <>
                            {menuItems.map((item, id) => 
                                <li className={`main-menu__item ${item.isVertical ? 'vertical-submenu' : ''}`} key={`mi-${id}`}>
                                    {item.url !== null ?
                                    <Link className="main-menu__link main-link" to={item.url?.replace('https://wp.bedbible.com', '')}>
                                        {item.label}
                                        {item.childrenItems.length > 0 &&
                                        <svg width="11" height="7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.1958 1.19751L5.79115 5.60213M1.3584 1.19751L5.76302 5.60213" stroke="#FF4D54" strokeWidth="1.5" strokeLinecap="round"/>
                                        </svg>}
                                    </Link>
                                    :
                                    <span className="main-menu__link main-link">
                                        {item.label}
                                        {item.childrenItems.length > 0 &&
                                        <svg width="11" height="7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.1958 1.19751L5.79115 5.60213M1.3584 1.19751L5.76302 5.60213" stroke="#FF4D54" strokeWidth="1.5" strokeLinecap="round"/>
                                        </svg>}
                                    </span>
                                    }
                                    {item.childrenItems.length > 0 &&
                                    <ul className="submenu">
                                        {item.childrenItems.map((itm, i) => 
                                        <li className="submenu__item" key={`sub-${i}`}>
                                            <Link className="submenu__item__link" to={itm.url?.replace('https://wp.bedbible.com', '')}>
                                                <span>{itm.label}</span>
                                                {itm?.childrenItems?.length > 0 &&
                                                <svg width="11" height="7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.1958 1.19751L5.79115 5.60213M1.3584 1.19751L5.76302 5.60213" stroke="#FF4D54" strokeWidth="1.5" strokeLinecap="round"/>
                                                </svg>
                                                }
                                            </Link>
                                            {itm?.childrenItems?.length > 0 &&
                                            <ul className="submenu__sub">
                                                {itm.childrenItems.map((it, i) =>   
                                                <li className="submenu__sub-item" key={`sub-${i}`}>
                                                    <Link className="submenu__sub-item__link" to={it.url?.replace('https://wp.bedbible.com', '')}>
                                                        <span>{it.label}</span>
                                                    </Link>
                                                </li>)}
                                            </ul>}
                                        </li>)}
                                    </ul>}
                                </li>
                            )}
                                                                        
                            <li className={'search-icon'} onClick={() => setSearch( true )}>
                                <svg width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5001 12.5202C14.7575 11.0106 15.3845 9.07439 15.2507 7.11427C15.1169 5.15415 14.2325 3.32107 12.7816 1.99637C11.3307 0.671672 9.42496 -0.0426614 7.46078 0.00197243C5.4966 0.0466062 3.62525 0.846771 2.23601 2.23601C0.846771 3.62525 0.0466062 5.4966 0.00197243 7.46078C-0.0426614 9.42496 0.671672 11.3307 1.99637 12.7816C3.32107 14.2325 5.15415 15.1169 7.11427 15.2507C9.07439 15.3845 11.0106 14.7575 12.5202 13.5001L16.8574 17.8372C16.9881 17.9634 17.1631 18.0333 17.3448 18.0317C17.5265 18.0301 17.7003 17.9573 17.8288 17.8288C17.9573 17.7003 18.0301 17.5265 18.0317 17.3448C18.0333 17.1631 17.9634 16.9881 17.8372 16.8574L13.5001 12.5202ZM1.40949 7.64603C1.40949 6.41256 1.77526 5.20679 2.46054 4.18119C3.14582 3.1556 4.11983 2.35625 5.25941 1.88422C6.39899 1.41219 7.65295 1.28869 8.86271 1.52933C10.0725 1.76996 11.1837 2.36394 12.0559 3.23613C12.9281 4.10833 13.5221 5.21957 13.7627 6.42934C14.0034 7.63911 13.8799 8.89307 13.4078 10.0326C12.9358 11.1722 12.1365 12.1462 11.1109 12.8315C10.0853 13.5168 8.8795 13.8826 7.64603 13.8826C5.99256 13.8807 4.40734 13.2231 3.23816 12.0539C2.06898 10.8847 1.41133 9.2995 1.40949 7.64603Z" fill="#FF4D54"/>
                                </svg>
                            </li>
                            </>}

                            {search && <SearchBlock setSearch={setSearch} allPosts={allPosts}/>}
                        </ul>

                        <div className={`${styles.burgerButton}`} ref={burgerRef} onClick={mobileMenuHandler} style={{ position : 'absolute', left : '20px', zIndex : 1001 }}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                    </div>
            </div>     
        </header>
        <MobileMenu menuItems={menuItems} mobileMenu={mobileMenu} />
        </>
    )
}

